import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>  
			<ChakraProvider>
				<App />
			</ChakraProvider>		
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
